import { JSX } from "react";

import { IconButton as MuiIconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

import { asTitle } from "utils/Utils";
import { ButtonSizeType } from "./ButtonTypes";

export type IconButtonProps = {
	tooltip: string;
	disabled?: boolean;
	icon: JSX.Element;
	size?: ButtonSizeType;

	onClick: () => void;
};

export default function IconButton(
	props: Readonly<IconButtonProps>
): JSX.Element {
	return (
		<Tooltip title={asTitle(props.tooltip)}>
			<span>
				<MuiIconButton
					aria-label={props.tooltip}
					disabled={props.disabled}
					onClick={props.onClick}
					size={props.size}>
					{props.icon}
				</MuiIconButton>
			</span>
		</Tooltip>
	);
}
